/**
 * Custom DataGrid filter operators
 */

import {
  getGridDateOperators,
  getGridStringOperators,
  GridFilterOperator,
} from "@mui/x-data-grid-premium";
import TopListedMultiselect from "../../components/Brand/UI/TopListedMultiselect";

/**
 * Custom filter operator for top-listed multiselect functionality
 */
export const topListedOperator: GridFilterOperator<any, string>[] = [
  {
    label: "Contains",
    value: "contains",
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return (value) => {
        return value.includes(filterItem.value);
      };
    },
    InputComponent: TopListedMultiselect,
    InputComponentProps: { type: "string" },
  },
];

/**
 * Server-side string filter operators (subset of available operators)
 */
export const serverFilterStringOperators = getGridStringOperators().filter(
  (operator) =>
    ["contains", "startsWith", "equals", "isEmpty", "isNotEmpty"].includes(
      operator.value
    )
);

/**
 * Server-side date filter operators (subset of available operators)
 */
export const serverFilterDateOperators = getGridDateOperators().filter(
  (operator) => ["is", "isEmpty", "isNotEmpty"].includes(operator.value)
);